import styled from 'styled-components';
import { EGradientDirection } from '../../Helper/enums';
import { createGradientOrSolid } from '../../Helper/utils/utils';

type PlaySimpleProps = {
  ribbonBadgeColor: {
    colorOne: string;
    colorTwo?: string;
    gradientDirection?: EGradientDirection;
  };
};

export const StyledPlaySimpleBundle = styled.div<PlaySimpleProps>`
  height: 64px;
  width: 100%;
  border-radius: 12px;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  font-family: var(--font-family), Arial;

  .container {
    padding-right: 8px;
    padding-left: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .price {
      width: 160px;
      margin-left: auto;
      height: 38px;
      border-radius: 30px;
      box-sizing: border-box;
      position: relative;
      z-index: 2;
      box-shadow: inset 0 -4px 0 0 rgba(20, 128, 29, 1);

      .totalPrice {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }
    }
  }

  .ac-ribbon-badge.ac-ribbon-badge--center {
    display: flex;
    position: absolute;
    top: -10px;
    left: -4px;
    bottom: auto;

    .ac-ribbon-badge__front {
      width: auto;
      padding-left: 20px;
      padding-right: 20px;
      display: flex;
      align-items: center;
      height: 20px;
      position: relative;
      left: 0;
      box-shadow: none;

      &__text {
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1), 0 0 20px rgba(0, 62, 76, 0.6);
        overflow: visible;
      }

      &:before {
        content: '';
        position: absolute;
        right: -7.8px;
        height: 20px;
        width: 8px;
        clip-path: polygon(0 0, 100% 50%, 0 100%);
        background: ${({ ribbonBadgeColor }) =>
          createGradientOrSolid(ribbonBadgeColor)};
      }

      &::after {
        content: '';
        position: absolute;
        background-color: #180029;
        width: 4px;
        height: 4px;
        bottom: -4px;
        left: 0;
        clip-path: polygon(0 0, 100% 100%, 100% 0);
      }
    }

    .ribbon-edge {
      display: none;
    }
  }
`;
